import React, { useEffect, useState } from 'react'
import { CloseModal, ModalContainer } from './style'
import ModalTest from '../../BaseModal'
import { useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import { X } from 'lucide-react'
import CertificatePDFGenerator from '../CertificatePDFGenerator/PDFTemplate'
import { CertificatePDFData } from '../CertificatePDFGenerator/types'

interface StructureColumn {
  name: string
  value: string
}

export interface Structure {
  name: string
  columns: StructureColumn[]
}

interface Param {
  name: string
  type: string
}

export interface Certificate {
  id: number
  date: string
  heatNumber: string
  customer: string
  supplier: string
  param: Param
  structures: Structure[]
  description?: string
  startingMaterial?: string
  images?:{
    id: number
    title: string
    subtitle?: string
    imageLink: string
  }[]
}


const ViewCertificateModal:React.FC = () => {
  const [ searchParam ] = useSearchParams()
  const id = searchParam.get('id')
  const navigate = useNavigate()
  const [ certificate, setCertificate ] = useState<CertificatePDFData>({
    customer:'',
    supplier:'',
    date:'',
    heatNumber:'',
    id:Number(id),
    param:{name:'',type:''},
    structures:[],
  })

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_CERTIFICATES_BASE_URL}/certificate/utils/view/${id}`)
      .then(response => {
        if(response.data) setCertificate(response.data)
      })
      .catch(error => {
        console.error(error)
      })
  }, [])
  
  return(
    <ModalTest>
      <ModalContainer>
        <CloseModal onClick={() => navigate('..')}> <X color='#696969'/> </CloseModal>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '100%',
          padding: '2rem',
          textAlign: 'center'
        }}>
          <h2 style={{ marginBottom: '1rem', color: '#1e40af' }}>
            Certificado #{certificate.id}
          </h2>
          <p style={{ marginBottom: '2rem', color: '#6b7280' }}>
            Cliente: {certificate.customer} | Nº da Corrida: {certificate.heatNumber}
          </p>
          <CertificatePDFGenerator certificate={certificate} />
        </div>
      </ModalContainer>
    </ModalTest>
  )
}

export default ViewCertificateModal